// extracted by mini-css-extract-plugin
module.exports = {"d2xDetailF":"F_d2xDetailF__ORRjD"};